import { Box, FormHelperText } from '@mui/material';
import {
  DesktopDatePicker as MuiDatePicker,
  DatePickerProps as MuiDatePickerProps,
  DesktopDateRangePicker as MuiDateRangePicker,
  DateRangePickerProps as MuiDateRangePickerProps,
} from '@mui/x-date-pickers-pro';
import { forwardRef } from 'react';
import { useGetLocale } from '@legacy/components/global/LocaleProvider';
import {
  getLanguageFromSiteLocale,
  localeDateFormat,
} from '@legacy/utils/date';
import { Typography } from '../Typography';

export const DatePicker = forwardRef<HTMLDivElement, MuiDatePickerProps>(
  ({ ...rest }, ref) => {
    const siteLocale = useGetLocale();
    const siteLanguage = getLanguageFromSiteLocale(siteLocale);
    return (
      <MuiDatePicker
        format={localeDateFormat(siteLanguage)}
        {...rest}
        ref={ref}
      />
    );
  },
);

interface IDateRangePicker extends MuiDateRangePickerProps {
  error?: boolean;
  helperText?: string[];
}

export const DateRangePicker = forwardRef<HTMLDivElement, IDateRangePicker>(
  ({ error, helperText, ...rest }, ref) => {
    const siteLocale = useGetLocale();
    const siteLanguage = getLanguageFromSiteLocale(siteLocale);
    return (
      <Box>
        <MuiDateRangePicker
          format={localeDateFormat(siteLanguage)}
          {...rest}
          ref={ref}
        />
        {helperText?.length ? (
          <FormHelperText error={error} sx={{ mt: 0.5, mx: 1.75 }}>
            {helperText.map((text) => (
              <Typography
                component="span"
                fontSize="inherit"
                key={text}
                sx={{ display: 'block' }}
              >
                {text}
              </Typography>
            ))}
          </FormHelperText>
        ) : null}
        {/* </LocalizationProvider> */}
      </Box>
    );
  },
);
